var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNoImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 298,
    height: 206,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    opacity: 0.24,
    d: "M0 0h298v206H0z"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(137 79)",
    fill: "#666",
    fontFamily: "FontAwesome5Pro-Light, Font Awesome 5 Pro",
    fontSize: 16,
    fontWeight: 300
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 4,
    y: 18
  }, "image")), /*#__PURE__*/React.createElement("text", {
    fontFamily: "Gibson-Regular, Gibson",
    fontSize: 12,
    fill: "#666"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 94.172,
    y: 121
  }, "Image is not available")))));
}

export default SvgNoImage;